import { render, staticRenderFns } from "./AddChildren.vue?vue&type=template&id=772d025e&scoped=true"
import script from "./AddChildren.vue?vue&type=script&lang=js"
export * from "./AddChildren.vue?vue&type=script&lang=js"
import style0 from "./AddChildren.vue?vue&type=style&index=0&id=772d025e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "772d025e",
  null
  
)

export default component.exports